//I WANT TO CREATE A SERVICE TO GET THE ORG MODULES FROM THE USER AND VALIDATE IF THE USER HAS ACCESS TO THE MODULE
import { Injectable } from '@angular/core';
import { UserSettingsService } from './user-setting.service';
import { Setting } from '../setting';

@Injectable({
  providedIn: 'root',
})
export class OrgModulesService {
  constructor(
    public setting: Setting,
    public userSettingsService: UserSettingsService,
  ) {}

  getOrgModules() {
    return this.userSettingsService.getUser()?.orgModules ?? [];
  }

  hasAccessToModule(module: string) {
    return this.userSettingsService.getUser()?.orgModules?.some(m => m.key === module) ?? false;
  }
}

export function getOrgModules() {
  return this.userSettingsService.getUser()?.orgModules ?? [];
}

export function hasAccessToModule(module: string) {
  return this.userSettingsService.getUser()?.orgModules?.some(m => m.key === module) ?? false;
}
